module.exports = __webpack_public_path__ + "static/media/02_aviara-burnaby.9b98f15e.jpg";